import React from 'react';
import { IHybridResponse } from '../../../logic/Models/Responses/SeedResponse';
import { PpgSelectedSeedRow } from './PpgSelectedSeedRow';

type Props = {
	selectedSeeds: IHybridResponse[],
	deleteSelectedseed: (seed: string) => void,
	filterId: string
}

const PpgSelectedSeedRowList = ({ selectedSeeds, deleteSelectedseed, filterId } : Props) => 
{
	return <div style={{ display:'flex', flexDirection:'column', overflowY:'auto' }}>
		{selectedSeeds
			.sort((a, b) => parseFloat(a.RelativeMaturity) - parseFloat(b.RelativeMaturity))
			.filter(s => s.CropId === filterId)
			.map(s => (
				<PpgSelectedSeedRow key={s.Id} seed={s} deleteSeed={deleteSelectedseed} />
			))}
	</div>;
};

export default PpgSelectedSeedRowList;